export default ({typeId}) => `
${typeId ? `
    <span class="title-format-badge contrast u-allCaps"><i class="icon-${typeId}" aria-hidden="true"></i>${window.html(typeId)}</span>
` : '' }
`;
